import TableRow from './components/TableRow'
import TableCell from './components/TableCell'

export default {
    TableRow,
    TableCell,
}
